module.exports = __webpack_public_path__ + "static/img/20.c6605fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/zh/20.png
// module id = oAnf
// module chunks = 0